import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_TITLE} from 'styles/FontConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY_DARK, RED} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

import {LabAutomationTransform} from '../RunSchemaSpecConstants';

interface LabAutomationTransformSectionHeaderProps {
  isCollapsed: boolean;
  setIsCollapsed: (val: boolean) => void;
  transform: LabAutomationTransform;
  handleRemoveTransform?: (() => void) | null;
  error: boolean;
}

export function LabAutomationTransformSectionHeader(
  props: LabAutomationTransformSectionHeaderProps
): JSX.Element {
  return (
    <div className={css(styles.transformSectionHeader)}>
      <Button
        className={css(styles.collapserChevron)}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        onClick={() => {
          props.setIsCollapsed(!props.isCollapsed);
        }}
        size={ButtonSize.SMALL}
        icon={props.isCollapsed ? 'chevron' : 'chevron-down'}
      />
      <span className={css(styles.transformSectionTitle)}>
        {props.transform.transformType
          ? capitalize(constantCaseToWords(props.transform.transformType))
          : 'New transform'}
      </span>
      {props.error ? (
        <BenchlingIcon icon="status-failed" className={css(styles.invalidTransformIcon)} />
      ) : null}
      {props.handleRemoveTransform ? (
        <Button
          className={css(styles.removeTransformButton)}
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          onClick={props.handleRemoveTransform}
          size={ButtonSize.SMALL}
          icon="close"
        />
      ) : null}
    </div>
  );
}

const styles = StyleSheet.create({
  collapserChevron: {
    color: GRAY_DARK,
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  invalidTransformIcon: {
    color: RED,
  },
  removeTransformButton: {
    color: GRAY_DARK,
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    marginLeft: 'auto',
  },
  transformSectionHeader: {
    marginLeft: '-9px',
    display: 'flex',
    alignItems: 'center',
  },
  transformSectionTitle: {
    ...FONT_PROXIMA_TITLE,
    marginRight: '6px',
  },
});
